import React from 'react';
import { post } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import { MODELS, ROUTES, selectKycStatus } from '../../../Lib/constants';
// import { validateAdminMobile, validateEmail } from '../../../Lib/helpers';
import { EditDealerKycURI } from '../../../Queries/dealer';

// const validations = {
//   email: ({ data }) => validateEmail(data?.email),
//   phonenumber: ({ data }) => validateAdminMobile(data?.phonenumber),
// };

const EditDealerKyc = (props) => {
  const { navigation } = props;
  const { setupState } = navigation?.state?.params?.item;

  // if (setupState === 'Pending' && kycStatus === 'Approved') {
  //   navigation.navigate(ROUTES.setupDealerAccount.name, {
  //     ...navigation.state.params,
  //   });
  // }

  return (
    <Form
      type="standard"
      uri={EditDealerKycURI}
      reloadEvent={ROUTES.ViewDealer.name}
      reloadOnChangeEvent={ROUTES.ViewDealer.name}
      beforeSubmit={({ data }) => ({
        updates: {
          kycStatus: data.kycStatus,
          previouslyOnKyc:
              data.kycStatus === 'Approved'
              && props.navigation.state.params.item.setupState === 'Pending'
                ? 'setup-dealer-account'
                : 'none',
        },
      })}
      onSubmit={({ data, updates }) => {
        post({
          data,
          updates,
          model: MODELS.Dealer,
        });
      }}
      afterSubmit={({ data }) => {
        if (data.kycStatus === 'Approved' && setupState === 'Pending') {
          navigation.navigate(ROUTES.setupDealerAccount.name, {
            ...navigation.state.params,
          });
        } else {
          navigation.pop();
        }
      }}
      mandatory={{ kycStatus: 1 }}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'name',
                    label: 'Dealership Name',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'username',
                    label: 'Username',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'phonenumber',
                    label: 'Mobile Number',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'email',
                    label: 'Email Id',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'dms',
                    label: 'Dealer Management System',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'vmpp',
                    label: 'Wholesale Valuation Subscription',
                    editable: false,
                  },

                  autoSuggestOptionsInput({
                    label: 'KYC Status',
                    field: 'kycStatus',
                    suggestionField: 'label',
                    valueField: 'label',
                    options: selectKycStatus,
                    keyField: 'label',
                    editable: true,
                  }),
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};

export default EditDealerKyc;
